<template>
    <div class="sales-action">
        <div>
            <b-dropdown text="Actions"
                        size="sm"
                        variant="primary-user"
                        class="dropdown-split-arrow">
                <b-dropdown-item @click="startFulfillment(orderId)"
                                variant="primary-user"
                                :disabled="error">
                    Start fulfillment
                </b-dropdown-item>
                <b-dropdown-item :to="{name: 'SingleOrder', params: {orderId: orderId, parentBred: {route: $route}}}">Open order details</b-dropdown-item>
                <b-dropdown-item @click="$root.$emit('bv::show::modal', `confirm-modal-${orderId}`)"
                                variant="danger">
                    Delete
                </b-dropdown-item>
            </b-dropdown>
            <confirm-modal :id="orderId" @confirm="deleteOrder(orderId)"/>
        </div>
    </div>
</template>

<script>
    import ConfirmModal from '~cp/UserPanel/Modals/ConfirmModal'

    export default {
        name: 'SalesActions',
        props: {
            orderId: {
                type: Number,
                required: true
            },
            updateList: {
                type: Function,
                required: true
            },
            error: {
                type: Boolean,
                required: true
            }
        },
        components: {
            ConfirmModal
        },
        data() {
            return {}
        },
        methods: {
            deleteOrder() {
                this.$store.dispatch('deleteOrder', this.orderId)
                    .then(() => this.updateList())
            },
            startFulfillment(id) {
                this.$emit('getDelivery', id)
            }
        }
    }
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/UserPanel/Pages/Orders/SalesActions.vue